import React from 'react'

import clsx from 'clsx'

import Display from 'components/Display'
import EmptyState from 'components/EmptyState'

import starSVG from 'assets/empty-state-star.svg'

import styles from './PercentDisplay.module.scss'

/** @type {import("./types").default} */
const PercentDisplay = ({ reviews = {}, variant = 'large' }) => {
  return (
    <div className={clsx('PercentDisplay', styles[variant], styles.root)}>
      {reviews.total > 0 ? (
        <>
          <Display display={reviews.positive_percentage || 0} subscript="%" variant={variant} />
        </>
      ) : (
        <EmptyState img={starSVG.src} variant={variant} text="No reviews" />
      )}
    </div>
  )
}

export default PercentDisplay
